import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Typography, Card, Button, Space } from 'antd';
import {
    TeamOutlined,
    TrophyOutlined,
    SafetyCertificateOutlined,
    GlobalOutlined,
    BankOutlined,
    HeartOutlined,
    CheckCircleOutlined,
    PhoneOutlined,
    EnvironmentOutlined,
    ClockCircleOutlined,
    ArrowRightOutlined,
    StarOutlined,
    ThunderboltOutlined,
    FileProtectOutlined,
    DollarOutlined,
    CustomerServiceOutlined,
} from '@ant-design/icons';
import Reveal from '../../../components/reveal/Reveal';
import './APropos.scss';

const { Title, Paragraph, Text } = Typography;

const valeurs = [
    {
        icon: <SafetyCertificateOutlined />,
        title: 'Confiance',
        desc: 'Nous batissons des relations durables avec nos clients, fondees sur la transparence et l\'integrite dans chacune de nos actions.',
    },
    {
        icon: <TeamOutlined />,
        title: 'Proximite',
        desc: 'Nos agences a Abidjan nous permettent d\'etre au plus pres de nos clients pour un service personnalise et reactif.',
    },
    {
        icon: <TrophyOutlined />,
        title: 'Excellence',
        desc: 'Nous visons l\'excellence dans chaque prestation, du premier conseil a la gestion de vos sinistres les plus complexes.',
    },
    {
        icon: <HeartOutlined />,
        title: 'Engagement',
        desc: 'Nous nous engageons a defendre vos interets face aux compagnies d\'assurances et a obtenir les meilleures conditions.',
    },
];

const chiffres = [
    { number: '8+', label: 'Compagnies partenaires', icon: <GlobalOutlined /> },
    { number: '14', label: 'Types d\'assurances', icon: <FileProtectOutlined /> },
    { number: '2', label: 'Agences a Abidjan', icon: <EnvironmentOutlined /> },
    { number: '24h', label: 'Delai de reponse', icon: <ClockCircleOutlined /> },
];

const partenaires = [
    'SUNU Assurances',
    'GNA Assurances',
    'NSIA Assurances',
    'AXA Assurances',
    'ATLANTA Assurances',
    'SALAM Assurances',
    'SERENITY Assurances',
    'NOVELIA Assurances',
];

const differences = [
    {
        icon: <DollarOutlined />,
        title: 'Economies garanties',
        desc: 'Nous comparons les tarifs de nos 8+ partenaires pour vous obtenir la meilleure couverture au prix le plus bas. Nos clients economisent en moyenne 20 a 30% sur leurs primes.',
    },
    {
        icon: <CustomerServiceOutlined />,
        title: 'Un conseiller dedie',
        desc: 'Chaque client beneficie d\'un interlocuteur unique qui connait son dossier. Un seul appel suffit pour toute question sur vos contrats, paiements ou sinistres.',
    },
    {
        icon: <ThunderboltOutlined />,
        title: 'Rapidite d\'execution',
        desc: 'Devis en 24h, souscription en 48h. En cas de sinistre, nous declenchons immediatement les procedures pour accelerer votre indemnisation.',
    },
    {
        icon: <SafetyCertificateOutlined />,
        title: 'Independance totale',
        desc: 'Nous ne sommes lies a aucune compagnie. Notre unique objectif est de defendre vos interets et de vous proposer les solutions les plus adaptees.',
    },
];

const agences = [
    {
        nom: 'Siege - 2 Plateaux Vallon',
        adresse: 'Abidjan, Cocody 2 Plateaux Vallon',
        tel: '+225 07 00 00 00 00',
        horaires: 'Lun - Ven : 8h00 - 17h30',
    },
    {
        nom: 'Agence Riviera Golf',
        adresse: 'Abidjan, Cocody Riviera Golf',
        tel: '+225 07 00 00 00 01',
        horaires: 'Lun - Ven : 8h00 - 17h30',
    },
];

export default function APropos() {
    const navigate = useNavigate();

    return (
        <div className="page-apropos">
            {/* Hero */}
            <section className="apropos-hero">
                <Reveal animation="fadeIn" duration={1000}>
                    <div className="hero-content">
                        <div className="hero-badge">
                            <StarOutlined /> Courtier agree depuis notre creation
                        </div>
                        <Title level={1} className="hero-title">A propos de CAP Assurances</Title>
                        <Paragraph className="hero-subtitle">
                            Societe de courtage d'assurances au service des particuliers
                            et des entreprises en Cote d'Ivoire. Votre protection, notre priorite.
                        </Paragraph>
                    </div>
                </Reveal>
            </section>

            {/* Chiffres cles */}
            <section className="chiffres-section">
                <div className="section-inner">
                    <Row gutter={[24, 24]}>
                        {chiffres.map((c, i) => (
                            <Col xs={12} sm={6} key={i}>
                                <Reveal animation="fadeUp" delay={i * 100}>
                                    <div className="chiffre-card">
                                        <div className="chiffre-icon">{c.icon}</div>
                                        <div className="chiffre-number">{c.number}</div>
                                        <div className="chiffre-label">{c.label}</div>
                                    </div>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Qui sommes nous */}
            <section className="section">
                <div className="section-inner">
                    <Row gutter={[48, 40]} align="middle">
                        <Col xs={24} lg={14}>
                            <Reveal animation="fadeLeft">
                                <Title level={2}>Qui sommes-nous ?</Title>
                                <div className="section-line left" />
                                <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
                                    <strong>CAP Assurances</strong> est une societe de courtage d'assurances
                                    immatriculee en Cote d'Ivoire. En tant que courtier, nous sommes le
                                    mandataire de nos clients et non des compagnies d'assurances. Cette
                                    independance est notre force : nous travaillons exclusivement pour vous.
                                </Paragraph>
                                <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
                                    Notre role est de negocier les meilleures conditions de couverture
                                    et de tarifs aupres de nos partenaires assureurs, pour vous garantir
                                    une protection optimale adaptee a vos besoins specifiques, que vous
                                    soyez un particulier ou une entreprise.
                                </Paragraph>
                                <Paragraph style={{ fontSize: 16, lineHeight: 1.8 }}>
                                    Avec des agences implantees a Abidjan (2 Plateaux Vallon et Riviera Golf),
                                    nous offrons un service de proximite et un accompagnement personnalise
                                    tout au long de la vie de vos contrats : de la souscription a la gestion
                                    de vos sinistres.
                                </Paragraph>
                                <Space style={{ marginTop: 8 }}>
                                    <Button type="primary" size="large" onClick={() => navigate('/contact')}>
                                        Nous contacter
                                    </Button>
                                    <Button size="large" onClick={() => navigate('/assurances')}>
                                        Nos assurances
                                    </Button>
                                </Space>
                            </Reveal>
                        </Col>
                        <Col xs={24} lg={10}>
                            <Reveal animation="fadeRight" delay={200}>
                                <div className="mission-card">
                                    <BankOutlined className="mission-icon" />
                                    <Title level={3} style={{ color: '#fff' }}>Notre mission</Title>
                                    <Paragraph style={{ color: 'rgba(255,255,255,0.9)', fontSize: 15, lineHeight: 1.7 }}>
                                        Accompagner et conseiller nos clients dans le choix, la souscription
                                        et la gestion de leurs contrats d'assurance, en leur garantissant
                                        les meilleures conditions du marche ivoirien.
                                    </Paragraph>
                                    <div className="mission-highlights">
                                        <div className="highlight-item">
                                            <CheckCircleOutlined /> Comparaison multi-compagnies
                                        </div>
                                        <div className="highlight-item">
                                            <CheckCircleOutlined /> Negociation des meilleurs tarifs
                                        </div>
                                        <div className="highlight-item">
                                            <CheckCircleOutlined /> Gestion complete des sinistres
                                        </div>
                                        <div className="highlight-item">
                                            <CheckCircleOutlined /> Suivi personnalise de vos contrats
                                        </div>
                                    </div>
                                </div>
                            </Reveal>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Ce qui nous differencie */}
            <section className="section bg-light">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Ce qui nous differencie</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                Pourquoi choisir un courtier plutot qu'une compagnie directe ?
                                Decouvrez les avantages concrets pour vous.
                            </Paragraph>
                        </div>
                    </Reveal>
                    <Row gutter={[24, 24]}>
                        {differences.map((d, i) => (
                            <Col xs={24} sm={12} lg={6} key={i}>
                                <Reveal animation="fadeUp" delay={i * 120}>
                                    <div className="difference-card">
                                        <div className="difference-icon">{d.icon}</div>
                                        <Title level={4}>{d.title}</Title>
                                        <Paragraph className="difference-desc">{d.desc}</Paragraph>
                                    </div>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Nos valeurs */}
            <section className="section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Nos valeurs fondamentales</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                Ces principes guident chacune de nos actions et engagements au quotidien
                            </Paragraph>
                        </div>
                    </Reveal>
                    <Row gutter={[24, 24]}>
                        {valeurs.map((v, i) => (
                            <Col xs={24} sm={12} lg={6} key={i}>
                                <Reveal animation="fadeUp" delay={i * 120}>
                                    <Card className="valeur-card" bordered={false}>
                                        <div className="valeur-icon">{v.icon}</div>
                                        <Title level={4}>{v.title}</Title>
                                        <Paragraph className="valeur-desc">{v.desc}</Paragraph>
                                    </Card>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Nos agences */}
            <section className="section bg-light">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Nos agences</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                Rendez-nous visite dans l'une de nos agences a Abidjan pour
                                un conseil personnalise
                            </Paragraph>
                        </div>
                    </Reveal>
                    <Row gutter={[32, 32]} justify="center">
                        {agences.map((a, i) => (
                            <Col xs={24} sm={12} md={10} key={i}>
                                <Reveal animation="fadeUp" delay={i * 150}>
                                    <Card className="agence-card" bordered={false}>
                                        <div className="agence-icon-wrap"><EnvironmentOutlined /></div>
                                        <Title level={4}>{a.nom}</Title>
                                        <div className="agence-infos">
                                            <div className="agence-info">
                                                <EnvironmentOutlined /> <span>{a.adresse}</span>
                                            </div>
                                            <div className="agence-info">
                                                <PhoneOutlined /> <span>{a.tel}</span>
                                            </div>
                                            <div className="agence-info">
                                                <ClockCircleOutlined /> <span>{a.horaires}</span>
                                            </div>
                                        </div>
                                        <Button type="primary" block onClick={() => navigate('/contact')} style={{ marginTop: 16 }}>
                                            Prendre rendez-vous
                                        </Button>
                                    </Card>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Partenaires */}
            <section className="section">
                <div className="section-inner">
                    <Reveal animation="fadeUp">
                        <div className="section-header">
                            <Title level={2}>Nos partenaires assureurs</Title>
                            <div className="section-line" />
                            <Paragraph className="section-desc">
                                Nous travaillons avec les compagnies d'assurances les plus
                                reconnues en Cote d'Ivoire et en Afrique de l'Ouest pour
                                vous offrir les meilleures garanties
                            </Paragraph>
                        </div>
                    </Reveal>
                    <Row gutter={[16, 16]} justify="center">
                        {partenaires.map((p, i) => (
                            <Col xs={12} sm={8} md={6} key={i}>
                                <Reveal animation="scaleIn" delay={i * 80}>
                                    <Card className="partenaire-card" bordered>
                                        <GlobalOutlined className="partenaire-icon" />
                                        <Text strong>{p}</Text>
                                    </Card>
                                </Reveal>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* CTA */}
            <Reveal animation="fadeIn">
                <section className="apropos-cta">
                    <div className="section-inner" style={{ textAlign: 'center' }}>
                        <Title level={2} style={{ color: '#fff', fontSize: 30 }}>
                            Envie d'en savoir plus ?
                        </Title>
                        <Paragraph style={{ color: 'rgba(255,255,255,0.85)', fontSize: 16, maxWidth: 550, margin: '0 auto 32px' }}>
                            Nos conseillers sont disponibles pour repondre a toutes vos questions
                            et vous accompagner dans le choix de votre assurance.
                        </Paragraph>
                        <Space size={16} wrap>
                            <Button
                                size="large"
                                style={{ background: '#fff', color: '#C8102E', fontWeight: 600, height: 48, paddingInline: 32 }}
                                icon={<PhoneOutlined />}
                                onClick={() => navigate('/contact')}
                            >
                                Nous contacter
                            </Button>
                            <Button
                                size="large"
                                ghost
                                style={{ height: 48, paddingInline: 32 }}
                                onClick={() => navigate('/assurances')}
                            >
                                Decouvrir nos assurances <ArrowRightOutlined />
                            </Button>
                        </Space>
                    </div>
                </section>
            </Reveal>
        </div>
    );
}
